import { Actions, ActionTypes } from '@appStore/app/actions';
import { Tip } from '@model'

export interface State {
    tips: Tip[],
    tipsLoaded: boolean,
    tipsLoading: boolean,
    showWindow: boolean
}

export const initialState: State = {
    tips: [],
    tipsLoaded: false,
    tipsLoading: false,
    showWindow: false
}

export function reducer(state = initialState, action: Actions): State {
    switch(action.type){
        case ActionTypes.TipsLoad:
            return {...state, tips: [], tipsLoaded: false, tipsLoading: true };
        case ActionTypes.TipsLoadSuccess:
            return {...state, tips: action.payload, tipsLoaded: true, tipsLoading: false };
        case ActionTypes.TipsLoadFail:
            return {...state, tips: [], tipsLoaded: false, tipsLoading: false };
        case ActionTypes.TipsOpen:
            return {...state, showWindow: true };
        case ActionTypes.TipsClose:
            return {...state, showWindow: false };
        case ActionTypes.TipSetAsReadSuccess:
            return {...state, tips: state.tips.map(tip => tip.id === action.payload.id ? action.payload : tip) };
    }
    return state;
}

export const _getIsTipsLoaded = (state: State) => state.tipsLoaded;
export const _getIsTipsLoading = (state: State) => state.tipsLoading;

export const _getUnreadTipsCount = (state: State) => state.tips.filter((tip) => !tip.isRead).length

export const _getIsTipWindowOpened = (state: State) => state.showWindow;

export const _getTips = (state: State) => state.tips;



